import Node from '../node.js';
import Spline, { RESAMPLE_LAST_POINT_OPTION } from '../spline.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';

export default class NodeResampleCurve extends Node
{
	static RESAMPLE_CHOICES =
	[
		{key: 'byDistance', label: 'By Distance'},
		{key: 'byNumPoints', label: 'By Number of Points'},
	]

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.SPLINE, 'spline', null);

		this.addInput(PARAM_TYPE.DROPDOWN, 'resample_type', NodeResampleCurve.RESAMPLE_CHOICES[0].key, { dropdownOptions: NodeResampleCurve.RESAMPLE_CHOICES });

		this.addInput(PARAM_TYPE.FLOAT, 'spacing', 0.1, { minValue: 0.001, maxValue: 0.5, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.INTEGER, 'num_points', 6, { minValue: 1, maxValue: 50 });

		this.addInput(PARAM_TYPE.BOOLEAN, 'preserve_corners', false);
		this.addInput(PARAM_TYPE.FLOAT, 'corner_angle', 90.0, { minValue: 0, maxValue: 180, units: PARAM_UNITS.DEGREES });

		this.addInput(PARAM_TYPE.FLOAT, 'start', 0.0, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, 'end', 100.0, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });

		this.addInput(PARAM_TYPE.BOOLEAN, 'extend_last_point', false);

		this.addOutput(PARAM_TYPE.SPLINE, 'geo');
	}

	getType()
	{ 
		return 'resampleCurve';
	}

	getIsInputEnabledSubclass(strInputName)
	{
		const lastResult = this.getLastInputResult('resample_type');
		if(strInputName === 'spacing' || strInputName === 'extend_last_point')
			return lastResult == NodeResampleCurve.RESAMPLE_CHOICES[0].key;
		else if(strInputName === 'num_points')
			return lastResult == NodeResampleCurve.RESAMPLE_CHOICES[1].key;

		return true;
	}

	getRefreshEnableStatusAfterParamChange(strInputName)
	{
		return strInputName == 'resample_type';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		if(!inputValues['spline'])
			return null;

		let pSpline = new Spline(inputValues['spline'])

		let fCornerAngle = null;
		if(inputValues['preserve_corners'])
			fCornerAngle = inputValues['corner_angle'];

		const lastPoint = inputValues['extend_last_point'] ? RESAMPLE_LAST_POINT_OPTION.EXTEND : RESAMPLE_LAST_POINT_OPTION.DELETE;

		let pRes;
		if(inputValues['resample_type'] == 'byDistance')
			pRes = pSpline.resampleByDistance(inputValues['spacing'], inputValues['start']/100.0, inputValues['end']/100.0, fCornerAngle, lastPoint);
		else
			pRes = pSpline.resampleByNumber(inputValues['num_points'], inputValues['start']/100.0, inputValues['end']/100.0, fCornerAngle);

		return pRes ? pRes.saveToObject() : null;
	}
}